import type { MotifComponent, MotifComponentProps } from '../../motif';
import { m } from '../../motif/m';

const subNavigationDefaultVars = {
  '--sub-navigation-item-color': m('--action-default-color'),
  '--sub-navigation-item-hover-color': m('--action-hover-color'),
  '--sub-navigation-item-active-color': m('--action-active-color'),
  '--sub-navigation-item-hover-decoration-color': m('--neutral-v300'),
};

export const subNavigationBlackBgVars: MotifComponentProps<MotifComponent.SUB_NAVIGATION> = {
  ...subNavigationDefaultVars,
  '--sub-navigation-item-active-color': m('--primary-v100'),
  '--sub-navigation-item-active-decoration-color': m('--neutral-v0'),
};

export const subNavigationYellowBgVars: MotifComponentProps<MotifComponent.SUB_NAVIGATION> = {
  ...subNavigationDefaultVars,
  '--sub-navigation-item-active-decoration-color': m('--neutral-v700'),
};

export const subNavigationGrayBgVars: MotifComponentProps<MotifComponent.SUB_NAVIGATION> = {
  ...subNavigationDefaultVars,
  '--sub-navigation-item-active-decoration-color': m('--neutral-v700'),
};

export const subNavigationWhiteBgVars: MotifComponentProps<MotifComponent.SUB_NAVIGATION> = {
  ...subNavigationDefaultVars,
  '--sub-navigation-item-active-decoration-color': m('--neutral-v700'),
};
